// DO NOT EDIT THIS FILE.
// THIS IS A GENERATED FILE AND ANY EDIT WILL BE REPLACED
// Home: github.com/00-team/argon
import * as ud from './user_defined';
export const API_VERSION = '0.1.0';

// @ts-ignore
type _Map<V> = { [key: string]: V }

export type AdminCompanyAddBody = { name:(string), };
export type AdminCompanyGetBulkBody = { ids:(((number)[])), };
export type AdminCompanyUpdateBody = { name:(string), };
export type AdminCooperationCount = { approved:(number),pending:(number),rejected:(number),total:(number), };
export type CooperationState = "pending"|"approved"|"rejected";
export const COOPERATION_STATE = ["pending","approved","rejected",] as const;
export function is_cooperation_state(value: string): value is CooperationState {
    return COOPERATION_STATE.includes(value as CooperationState)
}
;
export type AdminCooperationUpdateBody = { state:CooperationState, };
export type HelmetProvider = "day"|"tejaratno";
export const HELMET_PROVIDER = ["day","tejaratno",] as const;
export function is_helmet_provider(value: string): value is HelmetProvider {
    return HELMET_PROVIDER.includes(value as HelmetProvider)
}
;
export type AdminHelmetAddBody = { added_tax:(number),added_toll:(number),airrm_cover_financial:(number),airrm_cover_life:(number),airrm_cover_passenger:(number),cargo?:(((number) | null)),chassis:(string),company?:(((number) | null)),economic_number:(string),engine:(string),expiration_date:(string),financial_surplus_insurance_amount:(number),fund_fine:(number),insurance_code:(number),insurance_number:(number),insurer:(string),insurer_code:(string),insurer_phone:(string),issue_date:(string),issue_time:(number),issue_year:(number),issuer:(string),issuer_code:(number),life_surplus_insurance_amount:(number),manufacture_year:(number),passenger_count:(number),passenger_insurance_amount:(number),past_expiration_date:(string),past_insurer:(string),plate_city:(string),plate_number:(string),plate_serial:(string),provider:HelmetProvider,reagent:(string),start_date:(string),third_party_insurance_amount:(number),total_insurance_amount:(number),unique_code:(string),v_color:(string),v_group:(string),v_name:(string),v_system:(string),v_usage:(string),vin:(string), };
export type AdminHelmetBulkSearchBody = { insurance_numbers:(((number)[])), };
export type AdminHelmetCargoAddBody = { date:(string),number:(string),reference:(string), };
export type AdminHelmetCargoUpdateBody = { date:(string),number:(string),reference:(string), };
export type AdminHelmetExtensionAddBody = { added_tax:(number),added_toll:(number),airrm_cover_financial:(number),airrm_cover_life:(number),airrm_cover_passenger:(number),apply_date:(string),chassis:(string),economic_number:(string),engine:(string),expiration_date:(string),ext_change:(string),ext_code:(number),ext_issue_date:(string),ext_number:(number),ext_row:(number),financial_surplus_insurance_amount:(number),fund_fine:(number),helmet?:(((number) | null)),insurance_code:(number),insurance_number:(number),insurer:(string),insurer_code:(string),insurer_phone:(string),issue_date:(string),issue_time:(number),issue_year:(number),issuer:(string),issuer_code:(number),life_surplus_insurance_amount:(number),manufacture_year:(number),passenger_count:(number),passenger_insurance_amount:(number),past_expiration_date:(string),past_insurer:(string),plate_city:(string),plate_number:(string),plate_serial:(string),reagent:(string),start_date:(string),third_party_insurance_amount:(number),total_insurance_amount:(number),transaction_detail:(string),transaction_kind:(string),transaction_number:(number),transaction_summary:(string),unique_code:(string),v_color:(string),v_group:(string),v_name:(string),v_system:(string),v_usage:(string),vin:(string), };
export type HelmetExtensionRequestState = "pending"|"in_progress"|"rejected"|"done";
export const HELMET_EXTENSION_REQUEST_STATE = ["pending","in_progress","rejected","done",] as const;
export function is_helmet_extension_request_state(value: string): value is HelmetExtensionRequestState {
    return HELMET_EXTENSION_REQUEST_STATE.includes(value as HelmetExtensionRequestState)
}
;
export type AdminHelmetExtensionRequestUpdateBody = { state:HelmetExtensionRequestState, };
export type AdminHelmetExtensionUpdateBody = { added_tax:(number),added_toll:(number),airrm_cover_financial:(number),airrm_cover_life:(number),airrm_cover_passenger:(number),apply_date:(string),chassis:(string),economic_number:(string),engine:(string),expiration_date:(string),ext_change:(string),ext_code:(number),ext_issue_date:(string),ext_number:(number),ext_row:(number),financial_surplus_insurance_amount:(number),fund_fine:(number),helmet?:(((number) | null)),insurance_code:(number),insurance_number:(number),insurer:(string),insurer_code:(string),insurer_phone:(string),issue_date:(string),issue_time:(number),issue_year:(number),issuer:(string),issuer_code:(number),life_surplus_insurance_amount:(number),manufacture_year:(number),passenger_count:(number),passenger_insurance_amount:(number),past_expiration_date:(string),past_insurer:(string),plate_city:(string),plate_number:(string),plate_serial:(string),reagent:(string),start_date:(string),third_party_insurance_amount:(number),total_insurance_amount:(number),transaction_detail:(string),transaction_kind:(string),transaction_number:(number),transaction_summary:(string),unique_code:(string),v_color:(string),v_group:(string),v_name:(string),v_system:(string),v_usage:(string),vin:(string), };
export type AdminHelmetUpdateBody = { added_tax:(number),added_toll:(number),airrm_cover_financial:(number),airrm_cover_life:(number),airrm_cover_passenger:(number),cargo?:(((number) | null)),chassis:(string),company?:(((number) | null)),economic_number:(string),engine:(string),expiration_date:(string),financial_surplus_insurance_amount:(number),fund_fine:(number),insurance_code:(number),insurance_number:(number),insurer:(string),insurer_code:(string),insurer_phone:(string),issue_date:(string),issue_time:(number),issue_year:(number),issuer:(string),issuer_code:(number),life_surplus_insurance_amount:(number),manufacture_year:(number),passenger_count:(number),passenger_insurance_amount:(number),past_expiration_date:(string),past_insurer:(string),plate_city:(string),plate_number:(string),plate_serial:(string),provider:HelmetProvider,reagent:(string),start_date:(string),third_party_insurance_amount:(number),total_insurance_amount:(number),unique_code:(string),v_color:(string),v_group:(string),v_name:(string),v_system:(string),v_usage:(string),vin:(string), };
export type AdminUserAddBody = { password:(string),username:(string), };
export type AdminUserCount = { admins:(number),agents:(number),managers:(number),total:(number), };
export type AdminUserGetBulkBody = { ids:(((number)[])), };
export type AdminUserSetAdminPermsBody = { admin_perms?:(((((number)[])) | null)), };
export type Province = "none"|"all"|"tehran"|"alborz"|"ardabil"|"bushehr"|"chaharmahal_bakhtiari"|"fars"|"gilan"|"golestan"|"hamadan"|"hormozgan"|"ilam"|"isfahan"|"kerman"|"kermanshah"|"khuzestan"|"kohgiluyeh_and_boyer_ahmad"|"kurdistan"|"lorestan"|"markazi"|"mazandaran"|"qazvin"|"qom"|"north_khorasan"|"razavi_khorasan"|"south_khorasan"|"semnan"|"sistan_baluchestan"|"east_azerbaijan"|"west_azerbaijan"|"yazd"|"zanjan";
export const PROVINCE = ["none","all","tehran","alborz","ardabil","bushehr","chaharmahal_bakhtiari","fars","gilan","golestan","hamadan","hormozgan","ilam","isfahan","kerman","kermanshah","khuzestan","kohgiluyeh_and_boyer_ahmad","kurdistan","lorestan","markazi","mazandaran","qazvin","qom","north_khorasan","razavi_khorasan","south_khorasan","semnan","sistan_baluchestan","east_azerbaijan","west_azerbaijan","yazd","zanjan",] as const;
export function is_province(value: string): value is Province {
    return PROVINCE.includes(value as Province)
}
;
export type StaffRole = "agent"|"manager";
export const STAFF_ROLE = ["agent","manager",] as const;
export function is_staff_role(value: string): value is StaffRole {
    return STAFF_ROLE.includes(value as StaffRole)
}
;
export type AdminUserUpdateBody = { banned:(boolean),name?:(((string) | null)),password?:(((string) | null)),province:Province,staff_at?:(((number) | null)),staff_role:StaffRole,username?:(((string) | null)), };
export type ErrorCode = "unknown"|"forbidden"|"forbidden_self_edit"|"bad_auth"|"not_found"|"not_unique"|"server_error"|"database_error"|"rate_limited"|"index_out_of_bounds"|"bad_image"|"encode_webp_error"|"user_banned"|"bad_phone"|"bad_username"|"password_mismatch"|"password_weak"|"password_too_long"|"string_too_long"|"bad_search_args"|"hxr_already_exists";
export const ERROR_CODE = ["unknown","forbidden","forbidden_self_edit","bad_auth","not_found","not_unique","server_error","database_error","rate_limited","index_out_of_bounds","bad_image","encode_webp_error","user_banned","bad_phone","bad_username","password_mismatch","password_weak","password_too_long","string_too_long","bad_search_args","hxr_already_exists",] as const;
export function is_error_code(value: string): value is ErrorCode {
    return ERROR_CODE.includes(value as ErrorCode)
}
;
export type AppErr = { code:ErrorCode,debug?:(((string) | null)),status:(number), };
export type Company = { agent_count:(number),created_at:(number),helmet_count:(number),id:(number),manager_count:(number),name:(string), };
export type CompanyHxrCount = { done?:(((number) | null)),in_progress?:(((number) | null)),pending?:(((number) | null)),rejected?:(((number) | null)),total:(number), };
export type CompanyRequestExtensionBody = { detail:(string), };
export type CooperatioRequestBody = { company:(string),detail:(string),email?:(((string) | null)),name:(string),phone:(string), };
export type Cooperation = { company:(string),detail:(string),email?:(((string) | null)),id:(number),name:(string),phone:(string),state:CooperationState, };
export type Count = { max_page:(number),total:(number), };
export type Helmet = { added_tax:(number),added_toll:(number),airrm_cover_financial:(number),airrm_cover_life:(number),airrm_cover_passenger:(number),cargo?:(((number) | null)),chassis:(string),company?:(((number) | null)),created_at:(number),economic_number:(string),engine:(string),expiration_date:(string),financial_surplus_insurance_amount:(number),fund_fine:(number),id:(number),insurance_code:(number),insurance_number:(number),insurer:(string),insurer_code:(string),insurer_phone:(string),issue_date:(string),issue_time:(number),issue_year:(number),issuer:(string),issuer_code:(number),life_surplus_insurance_amount:(number),manufacture_year:(number),passenger_count:(number),passenger_insurance_amount:(number),past_expiration_date:(string),past_insurer:(string),plate_city:(string),plate_number:(string),plate_serial:(string),print_count:(number),provider:HelmetProvider,reagent:(string),start_date:(string),third_party_insurance_amount:(number),total_insurance_amount:(number),unique_code:(string),v_color:(string),v_group:(string),v_name:(string),v_system:(string),v_usage:(string),vin:(string), };
export type HelmetCargo = { created_at:(number),date:(string),id:(number),number:(string),reference:(string), };
export type HelmetExtension = { added_tax:(number),added_toll:(number),airrm_cover_financial:(number),airrm_cover_life:(number),airrm_cover_passenger:(number),apply_date:(string),chassis:(string),created_at:(number),economic_number:(string),engine:(string),expiration_date:(string),ext_change:(string),ext_code:(number),ext_issue_date:(string),ext_number:(number),ext_row:(number),financial_surplus_insurance_amount:(number),fund_fine:(number),helmet?:(((number) | null)),id:(number),insurance_code:(number),insurance_number:(number),insurer:(string),insurer_code:(string),insurer_phone:(string),issue_date:(string),issue_time:(number),issue_year:(number),issuer:(string),issuer_code:(number),life_surplus_insurance_amount:(number),manufacture_year:(number),passenger_count:(number),passenger_insurance_amount:(number),past_expiration_date:(string),past_insurer:(string),plate_city:(string),plate_number:(string),plate_serial:(string),print_count:(number),reagent:(string),start_date:(string),third_party_insurance_amount:(number),total_insurance_amount:(number),transaction_detail:(string),transaction_kind:(string),transaction_number:(number),transaction_summary:(string),unique_code:(string),v_color:(string),v_group:(string),v_name:(string),v_system:(string),v_usage:(string),vin:(string), };
export type HelmetExtensionRequest = { company:(number),created_at:(number),detail:(string),helmet:(number),id:(number),state:HelmetExtensionRequestState,user:(number), };
export type HelmetIdIn = { id:(number),insurance_number:(number), };
export type HelmetSort = "plate_number";
export const HELMET_SORT = ["plate_number",] as const;
export function is_helmet_sort(value: string): value is HelmetSort {
    return HELMET_SORT.includes(value as HelmetSort)
}
;
export type SortOrder = "desc"|"asc";
export const SORT_ORDER = ["desc","asc",] as const;
export function is_sort_order(value: string): value is SortOrder {
    return SORT_ORDER.includes(value as SortOrder)
}
;
export type SearchHelmetBody = { chassis?:(((string) | null)),company?:(((number) | null)),created_at_from?:(((number) | null)),created_at_to?:(((number) | null)),engine?:(((string) | null)),insurance_number?:(((number) | null)),issue_date?:(((string) | null)),order?:((SortOrder | null)),page:(number),plate_number?:(((string) | null)),plate_serial?:(((string) | null)),sort?:((HelmetSort | null)),vin?:(((string) | null)), };
export type SearchHelmetCargoBody = { created_at_from?:(((number) | null)),created_at_to?:(((number) | null)),number?:(((string) | null)),page:(number),reference?:(((string) | null)), };
export type SearchHelmetExtensionBody = { chassis?:(((string) | null)),created_at_from?:(((number) | null)),created_at_to?:(((number) | null)),engine?:(((string) | null)),insurance_number?:(((number) | null)),issue_date?:(((string) | null)),page:(number),plate_number?:(((string) | null)),plate_serial?:(((string) | null)),vin?:(((string) | null)), };
export type StaffHelmetSearchBody = { chassis?:(((string) | null)),created_at_from?:(((number) | null)),created_at_to?:(((number) | null)),engine?:(((string) | null)),insurance_number?:(((number) | null)),order?:((SortOrder | null)),page:(number),plate_number?:(((string) | null)),plate_serial?:(((string) | null)),sort?:((HelmetSort | null)),vin?:(((string) | null)), };
export type StaffUserAddBody = { name?:(((string) | null)),password:(string),province:Province,username:(string), };
export type StaffUserCount = { agent:(number),manager:(number),total:(number), };
export type StaffUserGetBulkBody = { ids:(((number)[])), };
export type StaffUserUpdateBody = { banned:(boolean),name?:(((string) | null)),password?:(((string) | null)),province:Province,username?:(((string) | null)), };
export type User = { admin_perms?:(((((number)[])) | null)),banned:(boolean),created_at:(number),id:(number),name?:(((string) | null)),print_count:(number),province:Province,staff_at?:(((number) | null)),staff_role:StaffRole,username:(string), };
export type UserLoginBody = { password:(string),username:(string), };
export type UserSession = { id:(number),ip:(string),timestamp:(number),token:(string),user:(number), };
export type UserUpdateBody = { name?:(((string) | null)),old_password?:(((string) | null)),password?:(((string) | null)),username?:(((string) | null)), };
/**
List

*/
export async function api_admin_companies_list (params: {page:(number),}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<((Company[]))>> {
    let { page } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let r = await ud.httpx({
        url: `/api/admin/companies/`,
        method: 'GET',
        params: { page },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(),
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<((Company[]))> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<((Company[]))>

}
/**
Add

*/
export async function api_admin_companies_post (body: AdminCompanyAddBody, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<Company>> {
    
    let data = JSON.stringify(body);
    let ovh = override.headers || {};
    delete override.headers;
    let r = await ud.httpx({
        url: `/api/admin/companies/`,
        method: 'POST',
        params: {  },
        headers: { 'Content-Type': 'application/json', ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(),
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<Company> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<Company>

}
/**
Bulk

*/
export async function api_admin_companies_bulk_post (body: AdminCompanyGetBulkBody, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<((Company[]))>> {
    
    let data = JSON.stringify(body);
    let ovh = override.headers || {};
    delete override.headers;
    let r = await ud.httpx({
        url: `/api/admin/companies/bulk/`,
        method: 'POST',
        params: {  },
        headers: { 'Content-Type': 'application/json', ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(),
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<((Company[]))> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<((Company[]))>

}
/**
Count

*/
export async function api_admin_companies_count_get (override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<Count>> {
    
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let r = await ud.httpx({
        url: `/api/admin/companies/count/`,
        method: 'GET',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(),
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<Count> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<Count>

}
/**
Search

*/
export async function api_admin_companies_search_list (params: {name:(string),}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<((Company[]))>> {
    let { name } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let r = await ud.httpx({
        url: `/api/admin/companies/search/`,
        method: 'GET',
        params: { name },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(),
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<((Company[]))> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<((Company[]))>

}
/**
Get

*/
export async function api_admin_companies_get (params: {id:(number),}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<Company>> {
    let { id } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let r = await ud.httpx({
        url: `/api/admin/companies/${id}/`,
        method: 'GET',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(),
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<Company> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<Company>

}
/**
Delete

*/
export async function api_admin_companies_del (params: {id:(number),}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<void>> {
    let { id } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let r = await ud.httpx({
        url: `/api/admin/companies/${id}/`,
        method: 'DELETE',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(),
        status: r.status,
        body: void 0 as void,
        ok(): this is ud.Ok<void> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<void>

}
/**
Update

*/
export async function api_admin_companies_patch (params: {id:(number),}, body: AdminCompanyUpdateBody, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<Company>> {
    let { id } = params;
    let data = JSON.stringify(body);
    let ovh = override.headers || {};
    delete override.headers;
    let r = await ud.httpx({
        url: `/api/admin/companies/${id}/`,
        method: 'PATCH',
        params: {  },
        headers: { 'Content-Type': 'application/json', ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(),
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<Company> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<Company>

}
/**
List

*/
export async function api_admin_cooperations_list (params: {page:(number),state?:((CooperationState | null)),order?:((SortOrder | null)),}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<((Cooperation[]))>> {
    let { page,state,order } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let r = await ud.httpx({
        url: `/api/admin/cooperations/`,
        method: 'GET',
        params: { page,state,order },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(),
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<((Cooperation[]))> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<((Cooperation[]))>

}
/**
Count

*/
export async function api_admin_cooperations_count_get (override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<AdminCooperationCount>> {
    
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let r = await ud.httpx({
        url: `/api/admin/cooperations/count/`,
        method: 'GET',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(),
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<AdminCooperationCount> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<AdminCooperationCount>

}
/**
Get

*/
export async function api_admin_cooperations_get (params: {id:(number),}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<Cooperation>> {
    let { id } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let r = await ud.httpx({
        url: `/api/admin/cooperations/${id}/`,
        method: 'GET',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(),
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<Cooperation> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<Cooperation>

}
/**
Delete

*/
export async function api_admin_cooperations_del (params: {id:(number),}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<void>> {
    let { id } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let r = await ud.httpx({
        url: `/api/admin/cooperations/${id}/`,
        method: 'DELETE',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(),
        status: r.status,
        body: void 0 as void,
        ok(): this is ud.Ok<void> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<void>

}
/**
Update

*/
export async function api_admin_cooperations_patch (params: {id:(number),}, body: AdminCooperationUpdateBody, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<Cooperation>> {
    let { id } = params;
    let data = JSON.stringify(body);
    let ovh = override.headers || {};
    delete override.headers;
    let r = await ud.httpx({
        url: `/api/admin/cooperations/${id}/`,
        method: 'PATCH',
        params: {  },
        headers: { 'Content-Type': 'application/json', ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(),
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<Cooperation> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<Cooperation>

}
/**
List

*/
export async function api_admin_helmet_cargos_list (params: {page:(number),}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<((HelmetCargo[]))>> {
    let { page } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let r = await ud.httpx({
        url: `/api/admin/helmet-cargos/`,
        method: 'GET',
        params: { page },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(),
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<((HelmetCargo[]))> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<((HelmetCargo[]))>

}
/**
Add

*/
export async function api_admin_helmet_cargos_post (body: AdminHelmetCargoAddBody, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<HelmetCargo>> {
    
    let data = JSON.stringify(body);
    let ovh = override.headers || {};
    delete override.headers;
    let r = await ud.httpx({
        url: `/api/admin/helmet-cargos/`,
        method: 'POST',
        params: {  },
        headers: { 'Content-Type': 'application/json', ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(),
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<HelmetCargo> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<HelmetCargo>

}
/**
Count

*/
export async function api_admin_helmet_cargos_count_get (override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<Count>> {
    
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let r = await ud.httpx({
        url: `/api/admin/helmet-cargos/count/`,
        method: 'GET',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(),
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<Count> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<Count>

}
/**
Search

*/
export async function api_admin_helmet_cargos_search_post (body: SearchHelmetCargoBody, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<((HelmetCargo[]))>> {
    
    let data = JSON.stringify(body);
    let ovh = override.headers || {};
    delete override.headers;
    let r = await ud.httpx({
        url: `/api/admin/helmet-cargos/search/`,
        method: 'POST',
        params: {  },
        headers: { 'Content-Type': 'application/json', ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(),
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<((HelmetCargo[]))> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<((HelmetCargo[]))>

}
/**
Get

*/
export async function api_admin_helmet_cargos_get (params: {id:(number),}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<HelmetCargo>> {
    let { id } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let r = await ud.httpx({
        url: `/api/admin/helmet-cargos/${id}/`,
        method: 'GET',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(),
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<HelmetCargo> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<HelmetCargo>

}
/**
Delete

*/
export async function api_admin_helmet_cargos_del (params: {id:(number),}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<void>> {
    let { id } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let r = await ud.httpx({
        url: `/api/admin/helmet-cargos/${id}/`,
        method: 'DELETE',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(),
        status: r.status,
        body: void 0 as void,
        ok(): this is ud.Ok<void> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<void>

}
/**
Update

*/
export async function api_admin_helmet_cargos_patch (params: {id:(number),}, body: AdminHelmetCargoUpdateBody, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<HelmetCargo>> {
    let { id } = params;
    let data = JSON.stringify(body);
    let ovh = override.headers || {};
    delete override.headers;
    let r = await ud.httpx({
        url: `/api/admin/helmet-cargos/${id}/`,
        method: 'PATCH',
        params: {  },
        headers: { 'Content-Type': 'application/json', ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(),
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<HelmetCargo> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<HelmetCargo>

}
/**
List

*/
export async function api_admin_helmet_extension_requests_list (params: {page:(number),helmet?:(((number) | null)),company?:(((number) | null)),user?:(((number) | null)),state?:((HelmetExtensionRequestState | null)),}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<((HelmetExtensionRequest[]))>> {
    let { page,helmet,company,user,state } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let r = await ud.httpx({
        url: `/api/admin/helmet-extension-requests/`,
        method: 'GET',
        params: { page,helmet,company,user,state },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(),
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<((HelmetExtensionRequest[]))> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<((HelmetExtensionRequest[]))>

}
/**
Count

*/
export async function api_admin_helmet_extension_requests_count_get (params: {company?:(((number) | null)),user?:(((number) | null)),state?:((HelmetExtensionRequestState | null)),}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<Count>> {
    let { company,user,state } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let r = await ud.httpx({
        url: `/api/admin/helmet-extension-requests/count/`,
        method: 'GET',
        params: { company,user,state },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(),
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<Count> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<Count>

}
/**
Get

*/
export async function api_admin_helmet_extension_requests_get (params: {id:(number),}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<HelmetExtensionRequest>> {
    let { id } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let r = await ud.httpx({
        url: `/api/admin/helmet-extension-requests/${id}/`,
        method: 'GET',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(),
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<HelmetExtensionRequest> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<HelmetExtensionRequest>

}
/**
Delete

*/
export async function api_admin_helmet_extension_requests_del (params: {id:(number),}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<void>> {
    let { id } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let r = await ud.httpx({
        url: `/api/admin/helmet-extension-requests/${id}/`,
        method: 'DELETE',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(),
        status: r.status,
        body: void 0 as void,
        ok(): this is ud.Ok<void> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<void>

}
/**
Update

*/
export async function api_admin_helmet_extension_requests_patch (params: {id:(number),}, body: AdminHelmetExtensionRequestUpdateBody, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<HelmetExtensionRequest>> {
    let { id } = params;
    let data = JSON.stringify(body);
    let ovh = override.headers || {};
    delete override.headers;
    let r = await ud.httpx({
        url: `/api/admin/helmet-extension-requests/${id}/`,
        method: 'PATCH',
        params: {  },
        headers: { 'Content-Type': 'application/json', ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(),
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<HelmetExtensionRequest> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<HelmetExtensionRequest>

}
/**
List

*/
export async function api_admin_helmet_extensions_list (params: {page:(number),helmet?:(((number) | null)),}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<((HelmetExtension[]))>> {
    let { page,helmet } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let r = await ud.httpx({
        url: `/api/admin/helmet-extensions/`,
        method: 'GET',
        params: { page,helmet },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(),
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<((HelmetExtension[]))> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<((HelmetExtension[]))>

}
/**
Add

*/
export async function api_admin_helmet_extensions_post (body: AdminHelmetExtensionAddBody, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<HelmetExtension>> {
    
    let data = JSON.stringify(body);
    let ovh = override.headers || {};
    delete override.headers;
    let r = await ud.httpx({
        url: `/api/admin/helmet-extensions/`,
        method: 'POST',
        params: {  },
        headers: { 'Content-Type': 'application/json', ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(),
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<HelmetExtension> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<HelmetExtension>

}
/**
Count

*/
export async function api_admin_helmet_extensions_count_get (params: {hid?:(((number) | null)),}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<Count>> {
    let { hid } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let r = await ud.httpx({
        url: `/api/admin/helmet-extensions/count/`,
        method: 'GET',
        params: { hid },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(),
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<Count> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<Count>

}
/**
Search

*/
export async function api_admin_helmet_extensions_search_post (body: SearchHelmetExtensionBody, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<((HelmetExtension[]))>> {
    
    let data = JSON.stringify(body);
    let ovh = override.headers || {};
    delete override.headers;
    let r = await ud.httpx({
        url: `/api/admin/helmet-extensions/search/`,
        method: 'POST',
        params: {  },
        headers: { 'Content-Type': 'application/json', ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(),
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<((HelmetExtension[]))> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<((HelmetExtension[]))>

}
/**
Get

*/
export async function api_admin_helmet_extensions_get (params: {id:(number),}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<HelmetExtension>> {
    let { id } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let r = await ud.httpx({
        url: `/api/admin/helmet-extensions/${id}/`,
        method: 'GET',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(),
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<HelmetExtension> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<HelmetExtension>

}
/**
Delete

*/
export async function api_admin_helmet_extensions_del (params: {id:(number),}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<void>> {
    let { id } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let r = await ud.httpx({
        url: `/api/admin/helmet-extensions/${id}/`,
        method: 'DELETE',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(),
        status: r.status,
        body: void 0 as void,
        ok(): this is ud.Ok<void> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<void>

}
/**
Update

*/
export async function api_admin_helmet_extensions_patch (params: {id:(number),}, body: AdminHelmetExtensionUpdateBody, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<HelmetExtension>> {
    let { id } = params;
    let data = JSON.stringify(body);
    let ovh = override.headers || {};
    delete override.headers;
    let r = await ud.httpx({
        url: `/api/admin/helmet-extensions/${id}/`,
        method: 'PATCH',
        params: {  },
        headers: { 'Content-Type': 'application/json', ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(),
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<HelmetExtension> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<HelmetExtension>

}
/**
List

*/
export async function api_admin_helmets_list (params: {page:(number),company?:(((number) | null)),cargo?:(((number) | null)),sort?:((HelmetSort | null)),order?:((SortOrder | null)),}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<((Helmet[]))>> {
    let { page,company,cargo,sort,order } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let r = await ud.httpx({
        url: `/api/admin/helmets/`,
        method: 'GET',
        params: { page,company,cargo,sort,order },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(),
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<((Helmet[]))> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<((Helmet[]))>

}
/**
Add

*/
export async function api_admin_helmets_post (body: AdminHelmetAddBody, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<Helmet>> {
    
    let data = JSON.stringify(body);
    let ovh = override.headers || {};
    delete override.headers;
    let r = await ud.httpx({
        url: `/api/admin/helmets/`,
        method: 'POST',
        params: {  },
        headers: { 'Content-Type': 'application/json', ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(),
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<Helmet> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<Helmet>

}
/**
Bulk Search

*/
export async function api_admin_helmets_bulk_search_post (body: AdminHelmetBulkSearchBody, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<((HelmetIdIn[]))>> {
    
    let data = JSON.stringify(body);
    let ovh = override.headers || {};
    delete override.headers;
    let r = await ud.httpx({
        url: `/api/admin/helmets/bulk-search`,
        method: 'POST',
        params: {  },
        headers: { 'Content-Type': 'application/json', ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(),
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<((HelmetIdIn[]))> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<((HelmetIdIn[]))>

}
/**
Count

*/
export async function api_admin_helmets_count_get (params: {cid?:(((number) | null)),}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<Count>> {
    let { cid } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let r = await ud.httpx({
        url: `/api/admin/helmets/count/`,
        method: 'GET',
        params: { cid },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(),
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<Count> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<Count>

}
/**
Search

*/
export async function api_admin_helmets_search_post (body: SearchHelmetBody, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<((Helmet[]))>> {
    
    let data = JSON.stringify(body);
    let ovh = override.headers || {};
    delete override.headers;
    let r = await ud.httpx({
        url: `/api/admin/helmets/search/`,
        method: 'POST',
        params: {  },
        headers: { 'Content-Type': 'application/json', ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(),
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<((Helmet[]))> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<((Helmet[]))>

}
/**
Get

*/
export async function api_admin_helmets_get (params: {id:(number),}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<Helmet>> {
    let { id } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let r = await ud.httpx({
        url: `/api/admin/helmets/${id}/`,
        method: 'GET',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(),
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<Helmet> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<Helmet>

}
/**
Delete

*/
export async function api_admin_helmets_del (params: {id:(number),}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<void>> {
    let { id } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let r = await ud.httpx({
        url: `/api/admin/helmets/${id}/`,
        method: 'DELETE',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(),
        status: r.status,
        body: void 0 as void,
        ok(): this is ud.Ok<void> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<void>

}
/**
Update

*/
export async function api_admin_helmets_patch (params: {id:(number),}, body: AdminHelmetUpdateBody, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<Helmet>> {
    let { id } = params;
    let data = JSON.stringify(body);
    let ovh = override.headers || {};
    delete override.headers;
    let r = await ud.httpx({
        url: `/api/admin/helmets/${id}/`,
        method: 'PATCH',
        params: {  },
        headers: { 'Content-Type': 'application/json', ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(),
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<Helmet> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<Helmet>

}
/**
List

*/
export async function api_admin_users_list (params: {page:(number),is_admin?:(((boolean) | null)),company?:(((number) | null)),role?:((StaffRole | null)),order?:((SortOrder | null)),}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<((User[]))>> {
    let { page,is_admin,company,role,order } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let r = await ud.httpx({
        url: `/api/admin/users/`,
        method: 'GET',
        params: { page,is_admin,company,role,order },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(),
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<((User[]))> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<((User[]))>

}
/**
Add

*/
export async function api_admin_users_post (body: AdminUserAddBody, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<User>> {
    
    let data = JSON.stringify(body);
    let ovh = override.headers || {};
    delete override.headers;
    let r = await ud.httpx({
        url: `/api/admin/users/`,
        method: 'POST',
        params: {  },
        headers: { 'Content-Type': 'application/json', ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(),
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<User> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<User>

}
/**
Bulk

*/
export async function api_admin_users_bulk_post (body: AdminUserGetBulkBody, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<((User[]))>> {
    
    let data = JSON.stringify(body);
    let ovh = override.headers || {};
    delete override.headers;
    let r = await ud.httpx({
        url: `/api/admin/users/bulk/`,
        method: 'POST',
        params: {  },
        headers: { 'Content-Type': 'application/json', ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(),
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<((User[]))> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<((User[]))>

}
/**
Count

*/
export async function api_admin_users_count_get (override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<AdminUserCount>> {
    
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let r = await ud.httpx({
        url: `/api/admin/users/count/`,
        method: 'GET',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(),
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<AdminUserCount> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<AdminUserCount>

}
/**
Search

*/
export async function api_admin_users_search_list (params: {username:(string),company?:(((number) | null)),page:(number),}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<((User[]))>> {
    let { username,company,page } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let r = await ud.httpx({
        url: `/api/admin/users/search/`,
        method: 'GET',
        params: { username,company,page },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(),
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<((User[]))> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<((User[]))>

}
/**
Get

*/
export async function api_admin_users_get (params: {id:(number),}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<User>> {
    let { id } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let r = await ud.httpx({
        url: `/api/admin/users/${id}/`,
        method: 'GET',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(),
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<User> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<User>

}
/**
Delete

*/
export async function api_admin_users_del (params: {id:(number),}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<void>> {
    let { id } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let r = await ud.httpx({
        url: `/api/admin/users/${id}/`,
        method: 'DELETE',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(),
        status: r.status,
        body: void 0 as void,
        ok(): this is ud.Ok<void> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<void>

}
/**
Update

*/
export async function api_admin_users_patch (params: {id:(number),}, body: AdminUserUpdateBody, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<User>> {
    let { id } = params;
    let data = JSON.stringify(body);
    let ovh = override.headers || {};
    delete override.headers;
    let r = await ud.httpx({
        url: `/api/admin/users/${id}/`,
        method: 'PATCH',
        params: {  },
        headers: { 'Content-Type': 'application/json', ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(),
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<User> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<User>

}
/**
Set Admin Perms

*/
export async function api_admin_users_admin_perms_patch (params: {id:(number),}, body: AdminUserSetAdminPermsBody, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<User>> {
    let { id } = params;
    let data = JSON.stringify(body);
    let ovh = override.headers || {};
    delete override.headers;
    let r = await ud.httpx({
        url: `/api/admin/users/${id}/admin-perms/`,
        method: 'PATCH',
        params: {  },
        headers: { 'Content-Type': 'application/json', ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(),
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<User> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<User>

}
/**
Sessions

*/
export async function api_admin_users_sessions_list (params: {id:(number),}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<((UserSession[]))>> {
    let { id } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let r = await ud.httpx({
        url: `/api/admin/users/${id}/sessions/`,
        method: 'GET',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(),
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<((UserSession[]))> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<((UserSession[]))>

}
/**
Delete All Sessions

*/
export async function api_admin_users_sessions_del (params: {id:(number),}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<void>> {
    let { id } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let r = await ud.httpx({
        url: `/api/admin/users/${id}/sessions/`,
        method: 'DELETE',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(),
        status: r.status,
        body: void 0 as void,
        ok(): this is ud.Ok<void> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<void>

}
/**
Get

*/
export async function api_companies_get (params: {cid:(number),}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<Company>> {
    let { cid } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let r = await ud.httpx({
        url: `/api/companies/${cid}/`,
        method: 'GET',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(),
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<Company> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<Company>

}
/**
Helmet Extension Request List

*/
export async function api_companies_helmet_extension_requests_list (params: {cid:(number),page:(number),order?:((SortOrder | null)),state?:((HelmetExtensionRequestState | null)),}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<((HelmetExtensionRequest[]))>> {
    let { cid,page,order,state } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let r = await ud.httpx({
        url: `/api/companies/${cid}/helmet-extension-requests/`,
        method: 'GET',
        params: { page,order,state },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(),
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<((HelmetExtensionRequest[]))> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<((HelmetExtensionRequest[]))>

}
/**
Helmet Extension Request Count

*/
export async function api_companies_helmet_extension_requests_count_get (params: {cid:(number),}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<CompanyHxrCount>> {
    let { cid } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let r = await ud.httpx({
        url: `/api/companies/${cid}/helmet-extension-requests/count/`,
        method: 'GET',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(),
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<CompanyHxrCount> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<CompanyHxrCount>

}
/**
Helmet List

*/
export async function api_companies_helmets_list (params: {cid:(number),page:(number),order?:((SortOrder | null)),sort?:((HelmetSort | null)),}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<((Helmet[]))>> {
    let { cid,page,order,sort } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let r = await ud.httpx({
        url: `/api/companies/${cid}/helmets/`,
        method: 'GET',
        params: { page,order,sort },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(),
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<((Helmet[]))> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<((Helmet[]))>

}
/**
Helmet Count

*/
export async function api_companies_helmets_count_get (params: {cid:(number),}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<Count>> {
    let { cid } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let r = await ud.httpx({
        url: `/api/companies/${cid}/helmets/count/`,
        method: 'GET',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(),
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<Count> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<Count>

}
/**
Helmet Search

*/
export async function api_companies_helmets_search_post (params: {cid:(number),}, body: StaffHelmetSearchBody, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<((Helmet[]))>> {
    let { cid } = params;
    let data = JSON.stringify(body);
    let ovh = override.headers || {};
    delete override.headers;
    let r = await ud.httpx({
        url: `/api/companies/${cid}/helmets/search/`,
        method: 'POST',
        params: {  },
        headers: { 'Content-Type': 'application/json', ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(),
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<((Helmet[]))> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<((Helmet[]))>

}
/**
Helmet Get

*/
export async function api_companies_helmets_get (params: {cid:(number),hid:(number),}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<Helmet>> {
    let { cid,hid } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let r = await ud.httpx({
        url: `/api/companies/${cid}/helmets/${hid}/`,
        method: 'GET',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(),
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<Helmet> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<Helmet>

}
/**
Get Helmet Extensions

*/
export async function api_companies_helmets_extensions_list (params: {cid:(number),hid:(number),}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<((HelmetExtension[]))>> {
    let { cid,hid } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let r = await ud.httpx({
        url: `/api/companies/${cid}/helmets/${hid}/extensions/`,
        method: 'GET',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(),
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<((HelmetExtension[]))> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<((HelmetExtension[]))>

}
/**
Helmet Printed

*/
export async function api_companies_helmets_printed_post (params: {cid:(number),hid:(number),}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<void>> {
    let { cid,hid } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let r = await ud.httpx({
        url: `/api/companies/${cid}/helmets/${hid}/printed/`,
        method: 'POST',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(),
        status: r.status,
        body: void 0 as void,
        ok(): this is ud.Ok<void> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<void>

}
/**
Request Extension

*/
export async function api_companies_helmets_request_extension_post (params: {cid:(number),hid:(number),}, body: CompanyRequestExtensionBody, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<HelmetExtensionRequest>> {
    let { cid,hid } = params;
    let data = JSON.stringify(body);
    let ovh = override.headers || {};
    delete override.headers;
    let r = await ud.httpx({
        url: `/api/companies/${cid}/helmets/${hid}/request-extension/`,
        method: 'POST',
        params: {  },
        headers: { 'Content-Type': 'application/json', ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(),
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<HelmetExtensionRequest> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<HelmetExtensionRequest>

}
/**
User List

*/
export async function api_companies_users_list (params: {cid:(number),page:(number),role?:((StaffRole | null)),order:SortOrder,}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<((User[]))>> {
    let { cid,page,role,order } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let r = await ud.httpx({
        url: `/api/companies/${cid}/users/`,
        method: 'GET',
        params: { page,role,order },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(),
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<((User[]))> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<((User[]))>

}
/**
User Add

*/
export async function api_companies_users_post (params: {cid:(number),}, body: StaffUserAddBody, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<User>> {
    let { cid } = params;
    let data = JSON.stringify(body);
    let ovh = override.headers || {};
    delete override.headers;
    let r = await ud.httpx({
        url: `/api/companies/${cid}/users/`,
        method: 'POST',
        params: {  },
        headers: { 'Content-Type': 'application/json', ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(),
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<User> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<User>

}
/**
Users Bulk

*/
export async function api_companies_users_bulk_post (params: {cid:(number),}, body: StaffUserGetBulkBody, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<((User[]))>> {
    let { cid } = params;
    let data = JSON.stringify(body);
    let ovh = override.headers || {};
    delete override.headers;
    let r = await ud.httpx({
        url: `/api/companies/${cid}/users/bulk/`,
        method: 'POST',
        params: {  },
        headers: { 'Content-Type': 'application/json', ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(),
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<((User[]))> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<((User[]))>

}
/**
User Count

*/
export async function api_companies_users_count_get (params: {cid:(number),}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<StaffUserCount>> {
    let { cid } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let r = await ud.httpx({
        url: `/api/companies/${cid}/users/count/`,
        method: 'GET',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(),
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<StaffUserCount> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<StaffUserCount>

}
/**
User Search

*/
export async function api_companies_users_search_list (params: {cid:(number),username:(string),}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<((User[]))>> {
    let { cid,username } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let r = await ud.httpx({
        url: `/api/companies/${cid}/users/search/`,
        method: 'GET',
        params: { username },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(),
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<((User[]))> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<((User[]))>

}
/**
User Get

*/
export async function api_companies_users_get (params: {cid:(number),uid:(number),}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<User>> {
    let { cid,uid } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let r = await ud.httpx({
        url: `/api/companies/${cid}/users/${uid}/`,
        method: 'GET',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(),
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<User> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<User>

}
/**
User Del

*/
export async function api_companies_users_del (params: {cid:(number),uid:(number),}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<void>> {
    let { cid,uid } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let r = await ud.httpx({
        url: `/api/companies/${cid}/users/${uid}/`,
        method: 'DELETE',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(),
        status: r.status,
        body: void 0 as void,
        ok(): this is ud.Ok<void> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<void>

}
/**
User Update

*/
export async function api_companies_users_patch (params: {cid:(number),uid:(number),}, body: StaffUserUpdateBody, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<User>> {
    let { cid,uid } = params;
    let data = JSON.stringify(body);
    let ovh = override.headers || {};
    delete override.headers;
    let r = await ud.httpx({
        url: `/api/companies/${cid}/users/${uid}/`,
        method: 'PATCH',
        params: {  },
        headers: { 'Content-Type': 'application/json', ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(),
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<User> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<User>

}
/**
Request Cooperation

*/
export async function api_cooperation_post (body: CooperatioRequestBody, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<void>> {
    
    let data = JSON.stringify(body);
    let ovh = override.headers || {};
    delete override.headers;
    let r = await ud.httpx({
        url: `/api/cooperation/`,
        method: 'POST',
        params: {  },
        headers: { 'Content-Type': 'application/json', ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(),
        status: r.status,
        body: void 0 as void,
        ok(): this is ud.Ok<void> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<void>

}
/**
Get

*/
export async function api_user_get (override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<User>> {
    
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let r = await ud.httpx({
        url: `/api/user/`,
        method: 'GET',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(),
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<User> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<User>

}
/**
Update

*/
export async function api_user_patch (body: UserUpdateBody, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<User>> {
    
    let data = JSON.stringify(body);
    let ovh = override.headers || {};
    delete override.headers;
    let r = await ud.httpx({
        url: `/api/user/`,
        method: 'PATCH',
        params: {  },
        headers: { 'Content-Type': 'application/json', ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(),
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<User> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<User>

}
/**
Login

*/
export async function api_user_login_post (body: UserLoginBody, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<User>> {
    
    let data = JSON.stringify(body);
    let ovh = override.headers || {};
    delete override.headers;
    let r = await ud.httpx({
        url: `/api/user/login/`,
        method: 'POST',
        params: {  },
        headers: { 'Content-Type': 'application/json', ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(),
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<User> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<User>

}
/**
Logout

*/
export async function api_user_logout_post (override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<void>> {
    
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let r = await ud.httpx({
        url: `/api/user/logout/`,
        method: 'POST',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(),
        status: r.status,
        body: void 0 as void,
        ok(): this is ud.Ok<void> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<void>

}
/**
Sessions List

*/
export async function api_user_sessions_list (override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<((UserSession[]))>> {
    
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let r = await ud.httpx({
        url: `/api/user/sessions/`,
        method: 'GET',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(),
        status: r.status,
        body: await r.json(),
        ok(): this is ud.Ok<((UserSession[]))> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<((UserSession[]))>

}
/**
Delete Session

*/
export async function api_user_sessions_del (params: {sid:(number),}, override: Partial<ud.HttpxProps> = {}) : Promise<ud.Result<void>> {
    let { sid } = params;
    let data = void 0;
    let ovh = override.headers || {};
    delete override.headers;
    let r = await ud.httpx({
        url: `/api/user/sessions/${sid}/`,
        method: 'DELETE',
        params: {  },
        headers: {  ...ovh },
        data,
        ...override
    })

    return {
        r: r.clone(),
        status: r.status,
        body: void 0 as void,
        ok(): this is ud.Ok<void> {
            return this.status == 200
        },
        err(): this is ud.Err {
            return !this.ok()
        },
    } as ud.Result<void>

}
